import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  StringValueAccessor,
  CreateStringValueAccessorProvider,
  CreateStringValueValidationProvider,
} from '../../../shared/widgets/value-accessors/string-value-accessor';

@Component({
  selector: 'wl-common-data-view-selector',
  templateUrl: 'common-data-view-selector.component.html',
  providers: [
    CreateStringValueAccessorProvider(ComonDataViewSelectorComponent),
    CreateStringValueValidationProvider(ComonDataViewSelectorComponent),
  ],
    standalone: false
})
export class ComonDataViewSelectorComponent extends StringValueAccessor {
  @Input() public required: any;
  @Input() public disabled: any;
  @Input() public cssClass: string = '';
  @Input() public prompt: string = '';

  public constructor() {
    super();
  }

  public isValid = (): boolean => {
    return !this.required || !!this.value;
  };
}
